import { render } from "./Algorithms_Result.vue?vue&type=template&id=48749fb2"
import script from "./Algorithms_Result.vue?vue&type=script&lang=js"
export * from "./Algorithms_Result.vue?vue&type=script&lang=js"

import "./Algorithms_Result.vue?vue&type=style&index=0&id=48749fb2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__